var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[(!this.state.loaded)?_c('k-loader'):_vm._e(),_vm._v(" "),_c('k-nav',{ref:"nav"}),_vm._v(" "),_c('k-header'),_vm._v(" "),_c('k-slider',{ref:"slider"}),_vm._v(" "),_c('k-footer',{ref:"footer",attrs:{"fixed":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14564b58","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 52
// module chunks = 0